<template>
	<div class="search-results" v-if="results">
		<content-container>
			<h2>Search Results for: {{ $route.query.q  }} - ~{{ results.total || 0 }} Results</h2>
			<pagination v-model="page" :total="results.pages" v-if="results.pages > 1"></pagination>
			<div v-if="results && results.results" class="recipe" v-for="(result, index) in results.results">
				<router-link :to="result.link" class="image-link">
					<lazy-background :src="result.image"></lazy-background>
				</router-link>
				<div class="content">
					<h2><router-link :to="result.link">{{ result.title }}</router-link></h2>
					<div>{{ result.description }}</div>
				</div>
			</div>
			<pagination v-model="page" :total="results.pages" v-if="results.pages > 1"></pagination>
		</content-container>
	</div>
</template>

<script>
	import dataMixin from '../mixins/data';

	export default {
		mixins: [dataMixin],
		data() {
			return {
				url: '/json/search?q=' + (this.$route.query.q || '') + '&page=' + (this.$route.query.page || ''),
				page: (this.$route.query.page || '')
			};
		},
		watch: {
			async page() {
				await this.$navigate('/search?q=' + this.$route.query.q + '&page=' + this.page);
			}
		},
		computed: {
			search() {
				return this.$store.state.search;
			},
			results() {
				return this.$store.state.pageData;
			}
		},
		methods: {
			setSeo() {
				this.$setSeo({
					title: 'Pixelcore Development | Search',
					description: 'Search results for ',
					keywords: 'Pixelcore Development, search',
					image: '/images/front/logo-dark.png'
				});
			}
		}
	}
</script>